export const version = '0.8.11';
//# sourceMappingURL=version.js.map